import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BusyService } from './busy-service';

@Injectable({ providedIn: 'root' })
export abstract class BaseApiService {
  readonly baseUrl: string;

  constructor(
    protected http: HttpClient,
    private busyService: BusyService
  ) {
    this.baseUrl = environment.apiBaseUrl;
  }

  protected get<T>(endpoint: string): Observable<T> {
    this.busyService.setBusy(true);
    return this.http.get<T>(this.baseUrl + endpoint).pipe(
      finalize(() => this.busyService.setBusy(false))
    );
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    this.busyService.setBusy(true);
    return this.http.post<T>(this.baseUrl + endpoint, body).pipe(
      finalize(() => this.busyService.setBusy(false))
    );
  }

  protected put<T>(endpoint: string, body: any): Observable<T> {
    this.busyService.setBusy(true);
    return this.http.put<T>(this.baseUrl + endpoint, body).pipe(
      finalize(() => this.busyService.setBusy(false))
    );
  }

  protected delete<T>(endpoint: string): Observable<T> {
    this.busyService.setBusy(true);
    return this.http.delete<T>(this.baseUrl + endpoint).pipe(
      finalize(() => this.busyService.setBusy(false))
    );
  }
}
